/* myar-freeship: free-shipping progress bar in cart + shipping line on product page */
(function () {
  var PREVIEW_ONLY = false;
  try {
    if (PREVIEW_ONLY) {
      if (/[?&]myar_preview=1/.test(location.search)) sessionStorage.setItem('myarPreview', '1');
      if (sessionStorage.getItem('myarPreview') !== '1') return;
    }
  } catch (e) { if (PREVIEW_ONLY) return; }

  var THRESHOLD = 4000, FEE = 490; // shop currency (EUR) cents
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var T = {
    en: { left: 'You are {x} away from <b>free shipping</b>', done: '✓ Your order ships <b>free</b>', line: '<b>Free shipping</b> on orders over {t} · otherwise {f} · Delivery in 3–7 days' },
    de: { left: 'Noch {x} bis zum <b>kostenlosen Versand</b>', done: '✓ Ihre Bestellung wird <b>kostenlos</b> versandt', line: '<b>Kostenloser Versand</b> ab {t} · sonst {f} · Lieferung in 3–7 Tagen' },
    fr: { left: 'Plus que {x} pour la <b>livraison gratuite</b>', done: '✓ Votre commande est livrée <b>gratuitement</b>', line: '<b>Livraison gratuite</b> dès {t} · sinon {f} · Livraison en 3 à 7 jours' },
    it: { left: 'Ti mancano {x} per la <b>spedizione gratuita</b>', done: '✓ Il tuo ordine viaggia <b>gratis</b>', line: '<b>Spedizione gratuita</b> sopra {t} · altrimenti {f} · Consegna in 3–7 giorni' }
  }[lang] || null;
  if (!T) T = { left: 'You are {x} away from <b>free shipping</b>', done: '✓ Your order ships <b>free</b>', line: '<b>Free shipping</b> on orders over {t} · otherwise {f} · Delivery in 3–7 days' };

  var cur = (window.Shopify && Shopify.currency) || { active: 'EUR', rate: '1.0' };
  var rate = parseFloat(cur.rate) || 1;
  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur.active, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur.active; }
  }
  var thr = Math.round(THRESHOLD * rate), fee = Math.round(FEE * rate);

  var css = '.myar-fs{margin:0 0 12px;padding:10px 12px;border-radius:8px;background:#f6f6f6;font-size:13px;line-height:1.35;color:#222}' +
    '.myar-fs__bar{height:6px;border-radius:3px;background:#e2e2e2;margin-top:7px;overflow:hidden}' +
    '.myar-fs__fill{height:100%;background:#c9a24a;border-radius:3px;transition:width .4s ease}' +
    '.myar-fs--done{background:#eef7ee;color:#1d6b2c}.myar-fs--done .myar-fs__fill{background:#2e9e47}' +
    '.myar-ship{margin-top:10px;font-size:13px;color:#444;line-height:1.4}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function render(total) {
    var left = thr - total, done = left <= 0;
    var pct = Math.max(4, Math.min(100, Math.round(total / thr * 100)));
    var html = '<div>' + (done ? T.done : T.left.replace('{x}', '<b>' + money(left) + '</b>')) + '</div>' +
      '<div class="myar-fs__bar"><div class="myar-fs__fill" style="width:' + (done ? 100 : pct) + '%"></div></div>';
    var targets = document.querySelectorAll('.scd__footer, .sf-cart__form .scd__summary, form.sf-cart__form');
    targets.forEach(function (t) {
      var box = t.querySelector(':scope > .myar-fs');
      if (!box) { box = document.createElement('div'); box.className = 'myar-fs'; t.insertBefore(box, t.firstChild); }
      box.className = 'myar-fs' + (done ? ' myar-fs--done' : '');
      box.innerHTML = html;
    });
  }
  var busy = false;
  function refresh() {
    if (busy) return; busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price || 0); }).catch(function () {})
      .then(function () { busy = false; });
  }
  // re-check after any cart change made by the theme
  var of = window.fetch;
  window.fetch = function (u) {
    var p = of.apply(this, arguments);
    try { var s = typeof u === 'string' ? u : (u && u.url) || ''; if (/\/cart\/(add|change|update|clear)/.test(s)) p.then(function () { setTimeout(refresh, 300); }); } catch (e) {}
    return p;
  };
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-open-cart-drawer], .sf-cart-icon, a[href$="/cart"], .scd__close')) setTimeout(refresh, 400); });

  function productLine() {
    if (!/\/products\//.test(location.pathname) || document.querySelector('.myar-ship')) return;
    var anchor = null;
    var btns = document.querySelectorAll('form[action*="/cart/add"] button[name="add"]');
    for (var i = 0; i < btns.length; i++) { if (btns[i].offsetParent !== null) { anchor = btns[i]; break; } }
    if (!anchor) return;
    var form = anchor.closest('form');
    var pay = form.querySelector('.shopify-payment-button') || form.parentNode.querySelector('.shopify-payment-button');
    var d = document.createElement('div'); d.className = 'myar-ship';
    d.innerHTML = '🚚 ' + T.line.replace('{t}', money(thr)).replace('{f}', money(fee));
    if (pay) pay.parentNode.insertBefore(d, pay.nextSibling);
    else anchor.parentNode.parentNode.insertBefore(d, anchor.parentNode.nextSibling);
  }
  // the theme re-renders the drawer after changes; put the bar back if it disappears
  setInterval(function () {
    var t = document.querySelector('.scd__footer, form.sf-cart__form');
    if (t && !t.querySelector(':scope > .myar-fs')) refresh();
  }, 1200);
  function init() { refresh(); productLine(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
